import React from 'react';

export default function ToggleSwitch({
  id,
  checked,
  onChange,
  showStatus = true,
  statusId = 'switch-status',
  disabled = false
}: {
  id: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  showStatus?: boolean;
  statusId?: string;
  disabled?: boolean;
}) {
  return (
    <>
      <label className={ disabled ? 'switch switch--disabled' : 'switch' }>
        <input
          type="checkbox"
          id={ id }
          checked={ checked }
          disabled={ disabled }
          onChange={ (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.checked) }
        />{' '}
        <span className="slider round" />
      </label>{' '}
      {showStatus ? <span id={ statusId }>{ checked ? 'On' : 'Off' } </span> : null}
    </>
  );
}

